import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-16 md:py-24 bg-white" data-id="element-137">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-138">
        <FadeIn data-id="element-139">
          <div className="bg-cream-100 rounded-3xl p-8 md:p-12 border-2 border-teal-100 shadow-xl text-center" data-id="element-140">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-teal-900 mb-6" data-id="element-141">
              Recupera tu movilidad hoy mismo por menos de lo que cuesta una
              visita al médico.
            </h2>

            <p className="text-xl text-gray-700 mb-10" data-id="element-142">
              Obtén el sistema completo de alivio por un pago único.
            </p>

            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-10" data-id="element-143">
              <img src="https://cdn.magicpatterns.com/uploads/gvs8Y6MsgK19DdKBAUVeje/PORTADA.png" alt="Guía Digital" className="w-48 md:w-64 rounded-lg shadow-lg" data-id="element-144" />

              <div className="text-center md:text-left" data-id="element-145">
                <p className="text-gray-500 line-through text-2xl mb-2" data-id="element-146">
                  Valor: $49.99
                </p>
                <div className="flex items-end justify-center md:justify-start gap-2 mb-4" data-id="element-147">
                  <span className="text-2xl font-bold text-coral" data-id="element-148">
                    Precio Especial:
                  </span>
                  <span className="text-6xl font-black text-coral leading-none" data-id="element-149">
                    $6.39
                  </span>
                </div>
                <div className="flex items-center justify-center md:justify-start gap-2 text-teal-700 font-medium bg-teal-50 py-2 px-4 rounded-full inline-flex" data-id="element-150">
                  <ShieldCheck className="w-5 h-5" data-id="element-151" />
                  <span data-id="element-152">Pago único. Acceso de por vida.</span>
                </div>
              </div>
            </div>

            <div className="max-w-md mx-auto" data-id="element-153">
              <Button fullWidth className="py-5 text-xl" data-id="element-154">
                DESCARGAR MI GUÍA AHORA
              </Button>
              <p className="mt-4 text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-155">
                <span className="w-2 h-2 rounded-full bg-green-500 inline-block" data-id="element-156"></span>
                Acceso inmediato y privado a tu correo electrónico.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}